(() => {
  'use strict';
  if (window.MSWallGuideProducts) return;
  const guides = new Map([
    ['montering-boston', { handle: 'benders-boston-antikk-gra', section: 'boston-guide-deler', image: 'boston-blocks.png', roles: ['normalBlock', 'solebjelke', 'topp', 'connector', 'cornerBlock', 'halfEndBlock', 'betonglim', 'fiberduk', 'geonettSmall', 'geonettLarge'] }],
    ['montering-megasmart', { handle: 'benders-megasmart-stottemur', section: 'megasmart-guide-deler', roles: ['normalBlock', 'cornerBlock', 'distanse', 'solebjelke', 'topphelle', 'betonglim', 'fiberduk', 'geonettSmall', 'geonettLarge'] }],
    ['montering-megastone-150', { handle: 'benders-megastone-stottemur', section: 'megastone150-guide-deler', roles: ['normalBlock', 'cornerBlock', 'salebjelke', 'topphelle', 'fiberduk', 'betonglim', 'geonettSmall', 'geonettLarge'] }]
  ]);
  const initialized = new WeakSet();
  let active = null;
  let serial = 0;

  function imageFailed(image, callback) {
    image.addEventListener('error', callback, { once: true });
    if (image.isConnected && image.currentSrc && image.complete && !image.naturalWidth) callback();
  }

  function openProduct(card, trigger) {
    const source = card.querySelector('template[data-ms-wall-product-info]');
    if (!source?.content || trigger.hidden || !trigger.isConnected) return;
    if (active) active.dismiss();
    const dialog = document.createElement('dialog');
    dialog.className = 'ms-wall-products-dialog';
    dialog.setAttribute('aria-modal', 'true');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ms-wall-products-dialog__close';
    close.setAttribute('aria-label', 'Lukk produktinformasjon');
    close.textContent = '×';
    const content = document.createElement('div');
    content.className = 'ms-wall-products-dialog__body';
    content.append(source.content.cloneNode(true));
    const title = content.querySelector('.ms-wall-products__title');
    if (!title || !content.querySelector('.ms-wall-products__link')) return;
    title.id = `ms-wall-product-title-${++serial}`;
    dialog.setAttribute('aria-labelledby', title.id);
    dialog.append(close, content);
    const image = content.querySelector('img');
    if (image) imageFailed(image, () => { image.hidden = true; });
    const body = document.body;
    const previousOverflow = body.style.overflow;
    let closed = false;
    function cleanup() {
      if (closed) return;
      closed = true;
      if (active?.dialog === dialog) active = null;
      if (body.style.overflow === 'hidden') body.style.overflow = previousOverflow;
      dialog.remove();
      const focusTarget = trigger.hidden ? card.querySelector('[data-ms-wall-product-fallback]') : trigger;
      if (focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
    }
    // Handle close synchronously so a second open cannot inherit this dialog's lock.
    function dismiss() { if (dialog.open) dialog.close(); cleanup(); }
    close.addEventListener('click', dismiss);
    dialog.addEventListener('close', cleanup, { once: true });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); event.stopPropagation(); dismiss(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopPropagation(); dismiss(); return;
      }
      if (event.key !== 'Tab') return;
      const nodes = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')).filter((node) => !node.hidden && node.getClientRects().length);
      const first = nodes[0]; const last = nodes[nodes.length - 1];
      if (!first) { event.preventDefault(); close.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !nodes.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !nodes.includes(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
    });
    document.body.append(dialog);
    try { dialog.showModal(); } catch (_) { dialog.remove(); return; }
    active = { dialog, dismiss };
    // Only the local dialog manages this lock; retain pre-existing drawer locks.
    body.style.overflow = 'hidden';
    close.focus({ preventScroll: true });
  }

  function init(root = document) {
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    root.querySelectorAll('[data-ms-wall-guide-products-scope]').forEach((scope) => {
      const guide = guides.get(scope.dataset.guideHandle);
      if (initialized.has(scope) || !guide || guide.handle !== scope.dataset.productHandle) return;
      const roles = guide.roles;
      const source = scope.querySelector('template[data-ms-wall-products-template]');
      if (!source?.content) return;
      const section = scope.querySelector(`[id="${guide.section}"]`);
      if (!section || section.querySelector(".ms-wall-products")) return;
      const figures = Array.from(section.querySelectorAll("figure")).filter((figure) => {
        return Array.from(figure.querySelectorAll('img')).some((img) => {
          try { return new URL(img.getAttribute('src'), document.baseURI).pathname.split('/').pop() === guide.image; } catch (_) { return false; }
        });
      });
      if (guide.image && figures.length !== 1) return;
      const grid = source.content.querySelector('.ms-wall-products')?.cloneNode(true);
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('[data-ms-wall-product]'));
      if (cards.length !== roles.length || roles.some((role) => cards.filter((card) => card.dataset.msWallProduct === role).length !== 1)) return;
      if (cards.some((card) => !card.querySelector('[data-ms-wall-product-fallback][href]') || !card.querySelector('template[data-ms-wall-product-info]'))) return;
      cards.forEach((card) => {
        const button = card.querySelector('[data-ms-wall-product-open]');
        const fallback = card.querySelector('[data-ms-wall-product-fallback]');
        const image = button?.querySelector('img');
        if (!button || !image) return;
        imageFailed(image, () => {
          const focused = document.activeElement === button;
          button.hidden = true; fallback.hidden = false;
          if (focused) fallback.focus({ preventScroll: true });
        });
        button.addEventListener('click', () => openProduct(card, button));
      });
      if (guide.image) figures[0].replaceWith(grid);
      else section.append(grid);
      initialized.add(scope);
    });
  }
  window.MSWallGuideProducts = { version: '2026-09-30-wall-products-r1', init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
